import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";
//const rootUrl = "http://local.vbg.enjo.software/api/distributors/settings";

export function getActiveSettings() {
  const request = axios.get(urls.SETTINGS_URL);
  return { type: ActionTypes.GET_ACTIVE_SETTINGS, payload: request };
}


export function getSiteLinks() {
    const request = axios.get(urls.SITE_LINKS_URL);
    return { type: ActionTypes.GET_SITE_LINKS, payload: request };
}
